<template lang="html">
  <v-container
    fluid
    class="pt-0"
  >
    <v-row>
      <v-col cols="12">
        <material-card
          class="card-tabs"
          color="success"
        >
          <v-col
            slot="header"
          >
            <v-tabs
              v-model="active"
              background-color="transparent"
              slider-color="white"
              grow
              center-active
              show-arrows
            >
              <v-tab
                v-for="tab in tabs"
                :key="tab"
              >
                {{ tab }}
              </v-tab>
            </v-tabs>
          </v-col>

          <v-tabs-items 
            v-model="active"
          >
            <employee-promises-table-list
              v-show="isTabOne"
              ref="tableOne"
              @updated="refreshTables()"
            />

            <employee-promises-table-list
              v-show="isTabTwo"
              ref="tableTwo"
              :approved-promises="true"
              @updated="refreshTables()"
            />
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      EmployeePromisesTableList: () => import('@/components/employee/promises/TableList'),
    },
    data () {
      return {
        active: 0,
        tabs: [
          'Pending and Inactive Promises',
          'Active Promises',
        ],
      }
    },
    computed: {
      isTabOne () {
        return this.active === 0
      },
      isTabTwo () {
        return this.active === 1
      },
    },
    methods: {
      refreshTables () {
        this.$refs.tableOne.loadData()
        this.$refs.tableTwo.loadData()
      },
    },
  }
</script>

<style lang='css' scoped>
</style>
